import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Select,
  Text,
  VStack,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';
import TablaProgramasTurismo from './TablaProgramasTurismo';

const ProgramasTuristicos: React.FC = () => {
  const [planes, setPlanes] = useState<any[]>([]);
  const [planSeleccionado, setPlanSeleccionado] = useState<any>(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    setCargando(true);
    axiosInstance
      .get('/turismo/planes')
      .then((res) => setPlanes(res.data || []))
      .catch(() => setPlanes([]))
      .finally(() => setCargando(false));
  }, []);

  const handleSeleccionarPlan = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(e.target.value);
    const plan = planes.find((p) => p.id === id) || null;
    setPlanSeleccionado(plan);
  };

  return (
    <VStack spacing={6} align="stretch" px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <Box bg="white" borderRadius="md" p={4} boxShadow="sm">
        <Flex align="flex-end" gap={4} flexWrap="wrap">
          <FormControl w={{ base: 'full', md: '420px' }}>
            <FormLabel fontSize="sm" fontWeight="semibold">
              Selecciona un plan
            </FormLabel>
            <Select
              placeholder={cargando ? 'Cargando planes...' : 'Selecciona un plan...'}
              onChange={handleSeleccionarPlan}
              isDisabled={cargando}
            >
              {planes.map((plan) => (
                <option key={plan.id} value={plan.id}>
                  {plan.anio} - {plan.nombre}
                </option>
              ))}
            </Select>
          </FormControl>
        </Flex>
      </Box>

      {planSeleccionado ? (
        <TablaProgramasTurismo idPlan={planSeleccionado.id} nombrePlan={planSeleccionado.nombre} />
      ) : (
        <Box bg="white" borderRadius="md" p={8} textAlign="center" boxShadow="sm">
          <Text color="gray.400">Selecciona un plan para gestionar sus programas</Text>
        </Box>
      )}
    </VStack>
  );
};

export default ProgramasTuristicos;

